import React  from "react";
import { renderDate } from "../../../helpers/HelperMethods";
import SolutionComponents from "./SolutionComponents";

const DeletePowerAppSolutionDialogContent = ({solution}) => {

    return (
        <div key={solution.id}>
            <div>Environment: <b>{solution.name}</b></div>
            <div style={{margin: '10px 15px'}}>
            {
                solution.modified && 
                <div>This solution was last modified on <b>{renderDate(solution.modified)}</b>.</div>
            }
            {
                solution.isManagedSolution
                ? <div>
                    This is a managed solution. If deleted, all configurations and associated data (Dataverse tables) will be permanently deleted.
                </div>
                : <div>
                    This solution is in an unmanaged state. As a result, the solution will be backed up for 6 months, but not the data.<br /> 
                    During this period, environment owners can <a href="https://abb.sharepoint.com/sites/powerplatformhub/SitePages/KnowledgeBase/Recertification.aspx#environment-owner-how-to-restore-deleted-element">restore the solution</a> if needed. 
                </div>
            }
            {
                solution.supportingSolutions.some(x => x.isManagedSolution) &&
                <div>
                    This solution has at least one managed supporting solution. <br />
                    If the main solution is deleted, the managed supporting solution(s) will be permanently deleted.
                </div>
            }
            {
                solution.supportingSolutions.some(x => !x.isManagedSolution) &&
                <div>
                    This solution has at least one unmanaged supporting solution. If the main solution is deleted, the unmanaged supporting solution will be backed up for 6 months, but not the data. <br />
                    During this period, environment owners can <a href="https://abb.sharepoint.com/sites/powerplatformhub/SitePages/KnowledgeBase/Recertification.aspx#environment-owner-how-to-restore-deleted-element">restore the solution</a> if needed. 
                </div>
            }
            </div>
            <SolutionComponents solution={solution} headerText='Components' />
        </div>
    )
}
    
export default DeletePowerAppSolutionDialogContent;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/DeletePowerAppSolutionDialogContent.js